import { render, staticRenderFns } from "./Bento.vue?vue&type=template&id=30edb686&"
import script from "./Bento.vue?vue&type=script&lang=js&"
export * from "./Bento.vue?vue&type=script&lang=js&"
import style0 from "./Bento.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports